import { Game } from '@Game/Game';
import { GameStore } from '@GameStore/GameStore';
import { EGameStoreKeys, ISoundSettings } from '@GameStore/GameStoreSchema';
import EventsCenter from '@Managers/Events/EventsCenter';
import { EGameEvents } from '@Managers/Events/GameEvents';
import { Logger, LoggerLevel, LoggerSource } from '@Managers/Logger';
import LocalStorageItem from '@Managers/Storage/LocalStorageItem';
import LocalStorageManager from '@Managers/Storage/LocalStorageManager';
import { LocalStorageItemKeys } from '@Managers/Storage/LocalStorageManager.types';
import { SoundManager } from './SoundManager';

export class SoundSettingsManager {
    private readonly game: Game;
    private readonly gameStore: GameStore;
    private readonly manager: SoundManager;
    constructor(game: Game, manager: SoundManager) {
        Logger.log(LoggerLevel.Constructor, {
            class: 'SoundManager',
            message: 'SoundManager constructor',
            source: LoggerSource.Game
        });
        this.game = game;
        this.gameStore = this.game.gameStore;
        this.manager = manager;
    }

    public init(): void {
        const settings = LocalStorageManager.readItem(LocalStorageItemKeys.GAME_SOUNDS_SETTINGS);
        this.gameStore.on(EGameStoreKeys.SoundSettings, this.onSoundSettingsChange, this);

        if (settings) {
            const { muteAll, background, gambleShuffle, reelStop } = settings;
            this.gameStore.set(EGameStoreKeys.SoundSettings, { muteAll, background, gambleShuffle, reelStop });
        }
    }

    private onSoundSettingsChange(): void {
        const soundSettings = this.gameStore.get(EGameStoreKeys.SoundSettings);
        const soundsMuted = soundSettings.muteAll;

        const settings = JSON.stringify(soundSettings);
        LocalStorageManager.saveItem(new LocalStorageItem(LocalStorageItemKeys.GAME_SOUNDS_SETTINGS, settings));

        if (!this.manager.isMuted() && !soundsMuted) return;

        EventsCenter.emit(soundsMuted ? EGameEvents.MUTE : EGameEvents.UNMUTE);
    }

    public isSoundWithSettingEnabled(settingId: keyof ISoundSettings): boolean {
        return this.gameStore.get(EGameStoreKeys.SoundSettings)[settingId];
    }
}
